import { useLocation } from "react-router-dom";
import queryString from "query-string";
import axios from "axios";
import { useEffect, useState } from "react";
import { url } from "../../config";
import exportFromJSON from "export-from-json";

const ExportModal = ({ isOpen = false, onClose = () => {}, tableName }) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  const fileName = `${tableName}-export-file`;
  const exportType = exportFromJSON.types.csv;
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [listData, setlistData] = useState([]);

  function normalizeParsedParams(parsed) {
    const result = {};

    for (const [key, value] of Object.entries(parsed)) {
      const match = key.match(/^(\w+)\[(\w+)\]$/);
      if (match) {
        const [, parent, child] = match;
        if (!result[parent]) result[parent] = {};
        result[parent][child] = value;
      } else {
        result[key] = value;
      }
    }

    return result;
  }

  const exportFnc = () => {
    const rawFilters = queryString.parse(location.search, {
      arrayFormat: "bracket",
    });

    const filters = normalizeParsedParams(rawFilters);

    setLoading(true);
    axios
      .post(`${url}/model/${tableName}/export`, {
        ...filters,
      })
      .then((res) => {
        setLoading(false);
        console.log(res?.data?.data, "res");
        setlistData(res?.data?.data);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  const formatExportValue = (value) => {
    if (value === null || value === undefined) return "--";

    if (typeof value === "object") {
      try {
        return JSON.stringify(value);
      } catch (err) {
        return "--";
      }
    }

    if (typeof value === "boolean") {
      return value ? "Yes" : "No";
    }

    return value;
  };

  const onExportFnc = () => {
    const rows = listData?.rows || [];

    if (!rows.length) return;

    const headings = Object.keys(rows[0]); // auto headings

    const jsonArray = rows.map((row) => {
      const formattedRow = {};

      headings.forEach((heading) => {
        formattedRow[heading] = formatExportValue(row[heading]);
      });

      return formattedRow;
    });

    exportFromJSON({ data: jsonArray, fileName, exportType });
  };

  useEffect(() => {
    if (isOpen) {
      exportFnc();
    }
  }, [isOpen]);

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center"
          onClick={handleOverlayClick}
        >
          <div
            className="bg-white rounded-lg shadow-lg max-w-lg w-full md:p-10 p-4 relative"
            onClick={(e) => e.stopPropagation()}
          >
            <h1 className="text-center text-lg md:text-xl font-semibold text-gray-800">
              Are you sure you want to export?
            </h1>
            <div className="flex justify-between gap-5 mt-10">
              <button
                onClick={onClose}
                className="border border-primary text-primary text-base font-medium py-2 w-1/2 max-w-[14rem] rounded-md"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  onClose();
                  onExportFnc();
                }}
                className="bg-primary text-white text-base font-medium py-2 w-1/2 max-w-[12rem] rounded-md"
              >
                {loading ? "loading" : ""} Export
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ExportModal;
